import React from "react";
import moment from "moment";
import SignatureWithName from "../Reusable/SignatureWithName";
import { getMonthlyPhoneConsultationPerformerName } from "./pmSessionConsultation.helpers";
const _ = require("lodash");
function SessionNotes(props) {
  const notes = props.notes;
  const list = _.orderBy(notes, 'createdAt', 'desc');
  const notesRows = list.map((note) => {
    if (!note.pmMode.includes(props.pmMode)) {
      return false;
    }
    const signatureImage = note.careProvider ? note.careProvider.signatureImage : undefined;
    const name = note.careProvider ? note.careProvider.lname+" "+note.careProvider.fname : undefined;
    var signatureLink = signatureImage ? signatureImage : undefined;
    if (signatureLink && !signatureLink.indexOf("http") == 0) {
        signatureLink = "/" + signatureLink
    }
    return (
      <tr>
        <td style={{ wordBreak: 'break-word', maxWidth: 80 }}>{note.pmMode}</td>
        <td style={{ wordBreak: 'break-word', maxWidth: 200 }}>{note.comment}</td>
        <td style={{ whiteSpace: 'nowrap' }}>{note.time}</td>
        <td style={{ whiteSpace: 'nowrap' }}>{note.hadPhoneConsultation ? "Yes" : "No"}</td>
        <td style={{ wordBreak: 'break-word', maxWidth: 100 }}>{note.careProvider ? (note.careProvider.lname + " " + note.careProvider.fname) : "-"}</td>
        <td style={{ whiteSpace: 'nowrap' }}>{moment(note.createdAt).format("MM/DD/YYYY")}</td>
        <td style={{ wordBreak: 'break-word', maxWidth: 100 }}>{getMonthlyPhoneConsultationPerformerName(note) || "-"}</td>
        <td style={{ minWidth: 120 }}>
          <div className="session-div-signature">
            <SignatureWithName
              signature={signatureLink}
              isBorder={false}
              name={name}
            />
          </div>
        </td>
      </tr>
    );
  });
  return (
    <div>
    <table className="table table-bordered page-break-ka-after mb-4 attestation-print-table session-notes-table" style={{ tableLayout: 'fixed', width: '100%', fontSize: '11px' }}>
      <colgroup>
        <col style={{ width: '8%' }} />
        <col style={{ width: '28%' }} />
        <col style={{ width: '7%' }} />
        <col style={{ width: '7%' }} />
        <col style={{ width: '12%' }} />
        <col style={{ width: '8%' }} />
        <col style={{ width: '15%' }} />
        <col style={{ width: '15%' }} />
      </colgroup>
      <thead>
        <tr>
          <th colSpan="8" className="text-center text-dark">
            <h3 class="font-weight-bold">
              {props.pmMode} TOTALS  {props.pmModeTotal}
            </h3>
          </th>
        </tr>
        {notesRows && (
          <tr>
            <th className="text-center">Subject</th>
            <th className="text-center">Note</th>
            <th className="text-center">Time</th>
            <th className="text-center">Call Included</th>
            <th className="text-center">Created By</th>
            <th className="text-center">Created Date</th>
            <th className="text-center">Monthly Phone Consultation By</th>
            <th className="text-center">Signature</th>
          </tr>
        )}
      </thead>
      <tbody className="text-left">
        {notes && notesRows.length > 0 ? (
          notesRows
        ) : (
          <tr>
            <th
              colSpan="8"
              className="text-black text-danger text-center mx-auto"
            >
              No Record Found
            </th>
          </tr>
        )}
      </tbody>
    </table>
    </div>
  );
}

export default SessionNotes;
